/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { accountOrganizationSchema } from "./accountOrganizationSchema.ts";
import { addressSchema } from "./addressSchema.ts";
import { propertyTrackingStatusSchema } from "./propertyTrackingStatusSchema.ts";
import { propertyTransactionTypeSchema } from "./propertyTransactionTypeSchema.ts";
import { statePropertySchema } from "./statePropertySchema.ts";
import { z } from "zod";

export const propertyMainSchema = z.object({
      "id": z.string(),
  "reference": z.string().min(1).max(100).describe("La référence de l'annonce immobilière.").optional(),
  "creationDate": z.string().datetime().optional(),
  "updateDate": z.string().datetime().optional(),
  "organization": z.lazy(() => accountOrganizationSchema).optional(),
  "status": z.lazy(() => statePropertySchema).describe("Status des annonces immobilières :\n- PENDING: En attente de mandat\n- ACTIVE: En vente/location\n- COMPLETED: Vendu/Loué\n- ARCHIVED: Archivé\n- STANDBY: Suspendu\n").optional(),
  "trackingStatus": z.lazy(() => propertyTrackingStatusSchema).describe("Statut de suivi du cycle de vie (Règles métiers : Cycle de vie & statut de suivi) — libellés, phases et transitions autorisées dans form-rules/property-lifecycle.json. En mise à jour, absent : inchangé ; différent du statut courant : la transition doit être autorisée par le JSON (400 sinon). `status` reste l'état historique à cinq valeurs.\n").optional(),
  "transactionType": z.lazy(() => propertyTransactionTypeSchema).describe("Type de transaction :\n- SALE : SALE\n- RENTAL : Location\n- LIFETIME_SALE : Viager\n- AUCTION_SALE : Vente aux enchères\n- OFF_PLAN_SALE : VEFA (vente en l'état futur d'achèvement)\n").optional(),
  "address": z.lazy(() => addressSchema).optional()
      })